import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import { Box } from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import BackIcon from '@mui/icons-material/NavigateBefore';
import NextIcon from '@mui/icons-material/NavigateNext';
import LastPageIcon from '@mui/icons-material/LastPage';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import '../InvoiceModels/InvoiceModelSetup/css/style.css';
import { toast } from 'react-toastify';
import PDFViewer from '../InvoiceModels/InvoiceModelSetup/PDFViewer';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import DownloadIcon from '@mui/icons-material/Download';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { downloadInvoiceFile, getFileIcon } from '../Common/Utilities';
import Tooltip from '@mui/material/Tooltip';




export class InvoiceDocumentViewer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			documentDataUri: "",
			page: 1,
			pages: 1,
			scale: 1,
			invoiceDocumentOffset: {
				offsetTop: 0,
				offsetLeft: 0,
				offsetWidth: 0,
				offsetHeight: 0
			}
		};
		this.zoomDebounceTimer = null;
		this.load_Handler = this.load_Handler.bind(this);
		this.error_Handler = this.error_Handler.bind(this);
		this.documentLoadSuccess_Handler = this.documentLoadSuccess_Handler.bind(this);
		this.pageRenderSuccess_Handler = this.pageRenderSuccess_Handler.bind(this);
		this.calculateInvoiceDocumentSize = this.calculateInvoiceDocumentSize.bind(this);
		this.resize_Handler = this.resize_Handler.bind(this);

		window.addEventListener("resize", this.resize_Handler);

		this.fetchInvoiceDocument();
	}
	handleDownloadClick = () => {
		const { modelDefId, invoiceDocumentFileLocation, companyCode, mode } = this.props.info;

		if (!invoiceDocumentFileLocation) return;

		this.props.info.inProgress(true);

		downloadInvoiceFile(modelDefId, invoiceDocumentFileLocation, companyCode, mode)
			.catch(() => {
				toast.error('Failed to download the file.');
			})
			.finally(() => {
				this.props.info.inProgress(false);
			});
	};


	fetchInvoiceDocument() {
		var that = this;

		var modelDefId = this.props.info.modelDefId;
		var encodedFileLocation = encodeURIComponent(this.props.info.invoiceDocumentFileLocation);
		var companyCode = this.props?.info?.companyCode;
		var companyCodeQuery = companyCode ? ("&companyCode=" + encodeURIComponent(companyCode)) : "";

		this.props.info.inProgress(true);

		httpGet("/api/invoicedocument/view/" + modelDefId + "?invoiceDocumentFileLocation=" + encodedFileLocation + "&mode=" + encodeURIComponent(this.props?.info?.mode || '') + companyCodeQuery)
			.then((response) => {
				var data = response.data;

				this.setState({ documentDataUri: data });
			}).catch((error) => {
				this.setState({ documentDataUri: "" });

				this.error_Handler(null, error.response.data);
			});
	}

	load_Handler(event) {
		this.props.info.inProgress(false);
	}

	error_Handler(event, message) {
		this.props.info.inProgress(false);
		toast.error(message ? message : 'Invoice document not found');

		if (this.props.info.onClose) {
			this.props.info.onClose();
		}
	}

	documentLoadSuccess_Handler(pdfDocument) {
		this.setState({ pages: pdfDocument.numPages });
	}

	pageRenderSuccess_Handler(documentCanvas) {
		const container = documentCanvas.parentElement;
		documentCanvas.style.position = 'relative';
		documentCanvas.style.marginLeft = "0";
		documentCanvas.style.transformOrigin = "top left";
		documentCanvas.style.width = "auto";

		const waitForWidth = () => {
			const canvasWidth = documentCanvas.offsetWidth;
			const containerWidth = container.clientWidth;

			if (canvasWidth === 0) {
				requestAnimationFrame(waitForWidth);
				return;
			}

			if (canvasWidth < containerWidth) {
				container.style.justifyContent = "center";
			} else {
				container.style.justifyContent = "flex-start";
			}

			this.calculateInvoiceDocumentSize(documentCanvas);
			this.props.info.inProgress(false);
		};

		waitForWidth(); 
		
	}

	getMimeTypeFromBase64(data) {
		var returnValue = "";

		var mimeType = data.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/);

		if (mimeType) { return mimeType[0] };

		var base64 = data.replace(/^data:application\/(pdf);base64,/, '');

		switch (base64.charAt(0)) {
			case '/':
				returnValue = "image/jpeg";
				break;
			case 'R':
				returnValue = "image/gif";
				break;
			case 'i':
				returnValue = "image/png";
				break;
			case 'J':
				returnValue = "application/pdf";
				break;
			default:
				returnValue = "application/unknown";
				break;
		}

		return returnValue;
	}

	handlePrevious() {
		var page = this.state.page - 1 >= 1 ? this.state.page - 1 : this.state.page;

		this.setState({ page: page });
	}

	handleNext() {
		var page = this.state.page + 1 <= this.state.pages ? this.state.page + 1 : this.state.page;

		this.setState({ page: page });
	}


	zoomOut() {
		if (this.state.scale > 1) {
			const pdfContainer = document.getElementById("pdfContainer");
			const scrollLeft = pdfContainer.scrollLeft;
			const scrollTop = pdfContainer.scrollTop;

			const newScale = parseFloat((this.state.scale - 0.1).toFixed(2));
			if (this.zoomDebounceTimer) {
				clearTimeout(this.zoomDebounceTimer);
			}

			this.zoomDebounceTimer = setTimeout(() => {
				this.setState({ scale: newScale }, () => {
					// Restore scroll position after zooming
					pdfContainer.scrollLeft = scrollLeft;
					pdfContainer.scrollTop = scrollTop;
				});
				this.zoomDebounceTimer = null;
			}, 300);
		}
	}


	
	zoomIn() {
		const pdfContainer = document.getElementById("pdfContainer");
		const scrollLeft = pdfContainer.scrollLeft;
		const scrollTop = pdfContainer.scrollTop;

		const newScale = parseFloat((this.state.scale + 0.1).toFixed(2));
		if (newScale < 2.5) {
			if (this.zoomDebounceTimer) {
				clearTimeout(this.zoomDebounceTimer);
			}

			this.zoomDebounceTimer = setTimeout(() => {
				this.setState({ scale: newScale }, () => {
					// Restore scroll position after zooming
					pdfContainer.scrollLeft = scrollLeft;
					pdfContainer.scrollTop = scrollTop;
				});
				this.zoomDebounceTimer = null;
			}, 300);
		}
	}


	calculateInvoiceDocumentSize(imgInvoiceDocument) {

		let offsetTop = imgInvoiceDocument.offsetTop;
		let offsetLeft = imgInvoiceDocument.offsetLeft;
		let offsetWidth = imgInvoiceDocument.offsetWidth;
		let offsetHeight = imgInvoiceDocument.height;

		this.setState({ ...this.state, invoiceDocumentOffset: { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } });
	}

	resize_Handler(event) {
		var invoiceDocumentContainer;
		const mimeType = this.getMimeTypeFromBase64(this.state.documentDataUri);
		const isPDF = mimeType === "application/pdf";
		const isImage = mimeType.startsWith("image"); 

		if (isPDF) {
			invoiceDocumentContainer = document.getElementById("the-canvas");
		} else if (isImage) {
			invoiceDocumentContainer = document.getElementById("imgInvoiceDocument");
		}
		
		if (invoiceDocumentContainer) {
			this.calculateInvoiceDocumentSize(invoiceDocumentContainer);
		}
	}

	render() {
		const isPDF = this.getMimeTypeFromBase64(this.state.documentDataUri) === "application/pdf";
		const src = isPDF ? "" : this.state.documentDataUri;
		const errorHandler = src === "" ? null : this.error_Handler;
		const position = this.props.info.inline ? "relative" : "absolute";
		const fileIcon = getFileIcon(this.props?.info?.invoiceDocumentFileLocation, { width: 24, height: 24 });

		return (
			<Box className="mf-12 col-left" sx={{ backgroundColor: "#7a7a7a", p: 2 }}>
				<Box className="col-pdf-view">
					<Box className="pdfContainer">

						<Box sx={{ position: 'relative', display: "flex", justifyContent: "center", alignItems: "center", width: "100%", mb: 1 }}>
							{(this.props.info.isInvoiceReadOnly === 1 || this.props.info.isInvoiceReadOnly === 2) && (
								<Tooltip title={this.props.info.isInvoiceReadOnly === 2
									? "Approval stamping may not be applied because the PDF file requires optimization."
									: "Approval stamping cannot be applied because the PDF file is write-protected."} placement="bottom-end">
									<Box
										component="span"
										sx={{
											position: "absolute",
											left: 8,
											display: "flex",
											alignItems: "center",
											color: "warning.main"
										}}
									>
										<WarningAmberIcon fontSize="small" />
									</Box>
								</Tooltip>
							)}
							<Tooltip title="Zoom In">
								<IconButton aria-label="Zoom In" onClick={() => this.zoomIn()}>
									<ZoomInIcon />
								</IconButton>
							</Tooltip>
							<Tooltip title="Zoom Out">
								<IconButton aria-label="Zoom Out" onClick={() => this.zoomOut()}>
									<ZoomOutIcon />
								</IconButton>
							</Tooltip>
							
							<Tooltip title="Download">
								<span
									style={{
										position: "absolute",
										right: 8,
										display: "flex",
										alignItems: "center"
									}}
								>
									{fileIcon
										? React.cloneElement(fileIcon, {
											'aria-label': 'Download',
											onClick: this.handleDownloadClick
										})
										: null}
								</span>
							</Tooltip>
							
						</Box>

					
						<Box
							id="pdfContainer"
							sx={{
								overflow: "auto",
								width: "100%",
								maxHeight:950,
								position: "relative",
								display: "flex",
								justifyContent: "center",
								alignItems: "flex-start", 
								p: 1,
								"&::-webkit-scrollbar": { width: 5, height: 5 },
								"&::-webkit-scrollbar-thumb": { backgroundColor: "#B2B2B2B2", borderRadius: 4 },
							}}
						>
							<img
								id="imgInvoiceDocument"
								src={src}
								alt=""
								style={{ display: isPDF ? "none" : "" }}
								onLoad={this.load_Handler}
								onError={errorHandler}
							/>
							<PDFViewer
								file={this.state.documentDataUri}
								page={this.state.page}
								scale={this.state.scale}
								onDocumentLoadSuccess={this.documentLoadSuccess_Handler}
								onPageRenderSuccess={this.pageRenderSuccess_Handler}
								onError={this.error_Handler}
							/>
						</Box>

						{isPDF && (
							<Box sx={{
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								position: position,
								bottom: 4,
								width: "100%",
								mt: 1
							}}>
								<IconButton aria-label="First Page" onClick={() => this.setState({ page: 1 })}>
									<FirstPageIcon />
								</IconButton>
								<IconButton aria-label="Previous Page" onClick={() => this.handlePrevious()}>
									<BackIcon />
								</IconButton>
								<Box sx={{ mx: 2 }}>{this.state.page} / {this.state.pages}</Box>
								<IconButton aria-label="Next Page" onClick={() => this.handleNext()}>
									<NextIcon />
								</IconButton>
								<IconButton aria-label="Last Page" onClick={() => this.setState({ page: this.state.pages })}>
									<LastPageIcon />
								</IconButton>
							</Box>
						)}
					</Box>
				</Box>
			</Box>
		);
	}
}
